class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.subscriptionInput = this.querySelector(
      '.subscription-widget__container .subscription_checkbox'
    );

    this.sellingPlans = this.querySelectorAll(
      '.product-subscription__select .selling-plan'
    );

    this.sellingPlanSelect = this.querySelector(
      '.product-subscription__select input'
    );

    this.wrapper = this.querySelector('.subscription-widget__content');
    this.button = this.closest('.product-details')
      ?.querySelector('.add-to-cart-text');

    this.onSubscriptionToggle = this.onSubscriptionToggle.bind(this);
    this.onPlanClick = this.onPlanClick.bind(this);
  }

  connectedCallback() {
    this.subscriptionInput?.addEventListener(
      'change',
      this.onSubscriptionToggle
    );

    this.sellingPlans.forEach(plan => {
      plan.addEventListener('click', this.onPlanClick);
    });
  }

  disconnectedCallback() {
    this.subscriptionInput?.removeEventListener(
      'change',
      this.onSubscriptionToggle
    );

    this.sellingPlans.forEach(plan => {
      plan.removeEventListener('click', this.onPlanClick);
    });
  }

  // -----------------------
  // Subscription toggle
  // -----------------------
  onSubscriptionToggle(e) {
    const isChecked = e.currentTarget.checked;

    this.wrapper?.classList.toggle('active', isChecked);
    this.updateButtonPrice(isChecked);

    if (isChecked) {
      this.setPlan(this.sellingPlans[0]);
    } else {
      this.resetPlans();
      this.sellingPlanSelect.value = '';
      this.sellingPlanSelect.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }
  }

  // -----------------------
  // Plan click
  // -----------------------
  onPlanClick(e) {
    this.resetPlans();
    this.setPlan(e.currentTarget);
  }

  // -----------------------
  // Helpers
  // -----------------------
  setPlan(plan) {
    if (!plan) return;

    plan.classList.add('active');

    const planId = plan.dataset.sellingPlanId;
    this.sellingPlanSelect.value = planId;

    this.sellingPlanSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    console.log(planId, 'selected plan');
  }

  resetPlans() {
    this.sellingPlans.forEach(plan => {
      plan.classList.remove('active');
    });
  }

  updateButtonPrice(isSubscription) {
    if (!this.button) return;

    const prefix = this.button.innerText.split('$')[0];
    const input = this.querySelector('[name="product-subscription-input"]');

    const originPrice = input?.dataset.originPrice;
    const price = input?.dataset.price;

    this.button.innerText = prefix + (isSubscription ? price : originPrice);
  }
}

// Register component
if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}
